import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Rights } from '../models/rights';

@Injectable({
  providedIn: 'root'
})

export class IdentityRightsService {

  constructor(private http: HttpClient) { }

  getRights(userId: string) {
    return this.http.get(environment.identityUrl + "/api/user/" + userId + "/rights");
  }
  async updateRights(userId: string, rights: Rights) {
    return this.http.put(environment.identityUrl + "/api/user/" + userId + "/rights", rights);
  }
}
